import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Grid, Card, CardContent, Button, Typography } from '@mui/material'
import { Alert, StyledModal } from 'frame/components'
import { useFbtWebForm } from 'utils'
import { useNavigate } from 'react-router-dom'
import { constants } from './module'

const FBTWebForm = () => {

  const navigate = useNavigate()
  const { onSubmitFbtWebForm } = useFbtWebForm()
  const fbtWebForm = useSelector(state => state?.fbtSubmissions?.fbtWebForm)

  const [showConfirmSubmitModal, setShowConfirmationSubmitModal] = useState(false)

  const onProceed = () => navigate(constants.ROUTE_ADD_SUBMISSION) // show calendar view

  const onSubmit = () => {
    const payload = {
      token: fbtWebForm?.token,
      email: fbtWebForm?.email,
      availableForPvtUseAllMonth: true,
      entries: [],
    }
    console.log('[onAddFbtSubmission]: ', payload)
    onSubmitFbtWebForm(payload) // for all days of the month
    setShowConfirmationSubmitModal(false)
  }

  return (
    <>
      <Card
        sx={{
          marginY: 5,
          paddingTop: 5,
          paddingBottom: '300px',
          width: 960,
          '@media (max-width: 960px)': {
            width: '100%',
            margin: '20px 10px 0 10px',
          },
        }}>
        <CardContent>
          {!fbtWebForm?.token ? ( // to safeguard this view if no token is set in state
            <Alert severity="error">
            Invalid token. This FBT Submissions link is invalid or has been expired
            </Alert>
          ) : (
            <Grid container spacing={3}>
              <Grid xs={12} item>
                <Typography
                  gutterBottom
                  variant="h4"
                  align="center"
                  sx={{
                    fontWeight: 'bold'
                  }}>
                  Fringe Benefit Tax
                </Typography>
                <Typography gutterBottom variant="body1" align="center">
                  Was your vehicle available for private use for <strong>all days of last</strong> month?
                </Typography>
              </Grid>

              <Grid
                xs={12}
                item
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  '@media (max-width: 600px)': {
                    justifyContent: 'left',
                    display: 'block',
                  },
                }}>
                <Button
                  color="primary"
                  variant="contained"
                  sx={{
                    borderRadius: 25,
                    marginTop: 2,
                    marginRight: 2,
                    minWidth: 180,
                    '@media (max-width: 600px)': {
                      minWidth: '100%',
                    },
                  }}
                  onClick={() => setShowConfirmationSubmitModal(true)}>
                  Yes
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  sx={{
                    borderRadius: 25,
                    marginTop: 2,
                    marginRight: 2,
                    minWidth: 180,
                    '@media (max-width: 600px)': {
                      minWidth: '100%',
                    },
                  }}
                  onClick={onProceed}>
                  No
                </Button>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>

      {/* Fbt Submit for all days - Confirmations Modal */}
      <StyledModal
        open={showConfirmSubmitModal}
        title={``}
        onCancelLabel="Go Back"
        onCancel={() => setShowConfirmationSubmitModal(false)}
        onConfirmLabel="Submit"
        onConfirm={onSubmit}>
        Please confirm you have completed your submission and your vehicle was available for private use for all days of last month.
        <br /><br />
        Once you click Submit, you cannot return to this form or view your submission again.
      </StyledModal>
    </>
  )
}

export default FBTWebForm
